export default "__VITE_ASSET__DvGl9i96__"